import React from 'react'
import { Form } from '../../components/Form'
import { SchoolListingCategoryDropdown } from './SchoolListingCategoryDropdown'
import { StateDropdown } from '../Dropdown/StateDropdown'
import { Button, ButtonThemeType } from '../../components/Button'
import { ButtonType } from '../../components/Button/ButtonType.constants'
import { FormSectionHeaderText } from '../Text/FormSectionHeaderText'
import { NumberTextBox } from '../../components/TextBox/NumberTextBox'
import { TextBox } from '../../components/TextBox/TextBox'
import { EmailTextBox } from '../../components/TextBox/EmailTextBox'

interface ISchoolListingFormProps {
  isSubmitting: boolean
  onChange: (ff: object) => void
  formFields: object
  onSubmit: () => void
}

const SchoolListingForm: React.FC<ISchoolListingFormProps> = ({
  isSubmitting,
  onChange,
  onSubmit,
  formFields,
}) => (
  <Form onChange={onChange} formFields={formFields} onSubmit={onSubmit}>
    <FormSectionHeaderText>Your Details</FormSectionHeaderText>
    <TextBox
      labelText="Contact Name"
      name="contact.name"
      disabled={isSubmitting}
      required
    />
    <EmailTextBox
      labelText="Contact Email"
      name="contact.email"
      required
      disabled={isSubmitting}
    />
    <FormSectionHeaderText>Listing Details</FormSectionHeaderText>
    <TextBox
      name="data.title"
      labelText="Listing Title"
      required
      disabled={isSubmitting}
    />
    <SchoolListingCategoryDropdown
      name="data.categories"
      labelText="Listing Categories"
      isDisabled={isSubmitting}
      required
    />
    <TextBox
      name="data.description"
      labelText="Description"
      disabled={isSubmitting}
      isMultiLines
    />
    <TextBox
      labelText="Street"
      name="data.location.street"
      disabled={isSubmitting}
    />
    <TextBox
      labelText="Suburb"
      name="data.location.suburb"
      disabled={isSubmitting}
      required
    />
    <NumberTextBox
      labelText="Postcode"
      name="data.location.postcode"
      disabled={isSubmitting}
      required
    />
    <StateDropdown
      labelText="State"
      name="data.location.state"
      isDisabled={isSubmitting}
      required
      isShowBorder
      isMenuLeft={false}
      isInline={false}
      isMenuPositionDown={false}
    />
    <Button
      disabled={isSubmitting}
      theme={ButtonThemeType.PRIMARY}
      type={ButtonType.SUBMIT}
      label="Update Listing"
    >
      Submit
    </Button>
  </Form>
)

export { SchoolListingForm }
